import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

const DashboardSettingsComponent: React.FC = () => {
  const navigate = useNavigate();

  const items = [
    {
      title: 'Informations de compte',
      description: 'Gérez les infos de base de votre compte : adresse e-mail, identifiant et données personnelles.',
      url: '/dashboard/settings/profile',
    },
    {
      title: 'Sécurité et confidentialité',
      description: 'Gérez tout ce qui protège votre compte : mot de passe, méthodes de connexion et activité récente.',
      url: '/dashboard/settings/privacy',
    },
    {
      title: "Gestion de l'abonnement",
      description: 'Retrouvez les détails de votre abonnement : formule, renouvellement et facturation.',
      url: '/dashboard/settings/subscription',
    },
  ];

  return (
    <div className='flex w-full flex-col items-center justify-start gap-8 rounded-2xl bg-white p-8 shadow-md *:cursor-pointer'>
      {items.map((item, i) => (
        <Fragment key={i}>
          <div key={i} className='flex w-full flex-col justify-center gap-2' onClick={() => navigate(item.url)}>
            <p className='text-blue-primary text-lg font-bold'>{item.title}</p>
            <p className='text-black'>{item.description}</p>
          </div>
          {i + 1 !== items.length && <div className='border-b-gray-tertiary -my-1 w-full border-b'></div>}
        </Fragment>
      ))}
    </div>
  );
};

export default DashboardSettingsComponent;
